import { ConfVariantPicker } from './ConfVariantPicker';
import { connect as abstractPickerConnect } from './AbstractPicker';

class ConfVariantToggler extends ConfVariantPicker {
  itemsAsOptions(items) {
    return [
      super.itemsAsOptions(items).find(item => {
        if (!this.isSelected(item, this.props.selected, 'variant')) {
          return true;
        } else if (
          this.props.selected.id !== 'dont select' &&
          item.id !== 'dont select' &&
          item.id !== this.props.selected.id
        ) {
          return true;
        }
        return false;
      }),
    ];
  }
}

export default abstractPickerConnect(ConfVariantToggler);
